import { Application } from '@hotwired/stimulus'

import Dialog from '@stimulus-components/dialog'

import AccordionController from './accordion_controller'
import ButtonChoicesController from './button_choices_controller'
import CoachChatButtonController from './coach_chat_button_controller'
import CandidateChatController from './candidate_chat_controller'
import CoachChatController from './coach_chat_controller'
import MenuDropdownController from './menu_dropdown_controller'
import ModalController from './modal_controller'
import NavLinkController from './nav_link_controller'
import CopyLinkController from './copy_link_controller'
import ImageFallbackController from './image_fallback_controller'
import RadioButtonsController from './radio_buttons_controller'
import ResizableDividerController from './resizable_divider_controller'
import ChartjsController from './chartjs_controller'
import StackedDistributionChartController from './stacked_distribution_chart_controller'
import HrPortalBioController from './hr_portal/bio_controller'
import HrPortalProgramInformationController from './hr_portal/program_information_controller'
import HrPortalGlobalReferralController from './hr_portal/global_referral_controller'
import HrPortalGlobalProgramSelectController from './hr_portal/global_program_select_controller'
import HrPortalAccessProgramSelectController from './hr_portal/access_program_select_controller'
import HrPortalAccessRequestSeniorityController from './hr_portal/access_request_seniority_controller'
import HrPortalSlideOverController from './hr_portal/slide_over_controller'
import HrPortalProgressBarController from './hr_portal/progress_bar_controller'
import HrPortalInvitationController from './hr_portal/invitation_controller'
import HrPortalBulkInvitationsActionsController from './hr_portal/bulk_invitations_actions_controller'
import HrPortalMultipleInvitationsController from './hr_portal/multiple_invitations_controller'
import HrPortalCsmSchedulerController from './hr_portal/csm_scheduler_controller'
import HrPortalUpcomingMeetingsController from './hr_portal/upcoming_meetings_controller'
import HrPortalNotificationsController from './hr_portal/notifications_controller'
import HrPortalActivityStatusController from './hr_portal/activity_status_controller'
import PillNavController from './pill_nav_controller'
import HrPortalEventRegistrationController from './hr_portal/event_registration_controller'
import HrPortalReportingWindowController from './hr_portal/reporting_window_controller'
import HrPortalCollapsiblePanelController from './hr_portal/collapsible_panel_controller'
import HrPortalOfferTypeController from './hr_portal/offer_type_controller'
import HrPortalHelpFaqController from './hr_portal/help_faq_controller'

const application = Application.start()

application.register('dialog', Dialog)

application.register('accordion', AccordionController)
application.register('button-choices', ButtonChoicesController)
application.register('coach-chat-button', CoachChatButtonController)
application.register('candidate-chat', CandidateChatController)
application.register('coach-chat', CoachChatController)
application.register('menu-dropdown', MenuDropdownController)
application.register('modal', ModalController)
application.register('nav-link', NavLinkController)
application.register('copy-link', CopyLinkController)
application.register('image-fallback', ImageFallbackController)
application.register('radio-buttons', RadioButtonsController)
application.register('resizable-divider', ResizableDividerController)
application.register('chartjs', ChartjsController)
application.register(
  'stacked-distribution-chart',
  StackedDistributionChartController,
)
application.register('hr-portal-bio', HrPortalBioController)
application.register(
  'hr-portal-program-information',
  HrPortalProgramInformationController,
)
application.register(
  'hr-portal-global-referral',
  HrPortalGlobalReferralController,
)
application.register(
  'hr-portal-global-program-select',
  HrPortalGlobalProgramSelectController,
)
application.register(
  'access-program-select',
  HrPortalAccessProgramSelectController,
)
application.register(
  'access-request-seniority',
  HrPortalAccessRequestSeniorityController,
)
application.register('hr-portal-slide-over', HrPortalSlideOverController)
application.register('hr-portal-progress-bar', HrPortalProgressBarController)
application.register('hr-portal-invitation', HrPortalInvitationController)
application.register(
  'bulk-invitations-actions',
  HrPortalBulkInvitationsActionsController,
)
application.register(
  'hr-portal-multiple-invitations',
  HrPortalMultipleInvitationsController,
)
application.register('hr-portal-notifications', HrPortalNotificationsController)
application.register(
  'hr-portal-activity-status',
  HrPortalActivityStatusController,
)
application.register(
  'hr-portal-event-registration',
  HrPortalEventRegistrationController,
)
application.register(
  'hr-portal-reporting-window',
  HrPortalReportingWindowController,
)
application.register(
  'hr-portal-collapsible-panel',
  HrPortalCollapsiblePanelController,
)
application.register('hr-portal-offer-type', HrPortalOfferTypeController)
application.register('hr-portal-help-faq', HrPortalHelpFaqController)

import GeoChartController from './geo_chart_controller'
application.register('geo-chart', GeoChartController)
application.register('hr-portal-csm-scheduler', HrPortalCsmSchedulerController)
application.register(
  'hr-portal-upcoming-meetings',
  HrPortalUpcomingMeetingsController,
)
application.register('pill-nav', PillNavController)

import DropdownController from '@stimulus-components/dropdown'
application.register('dropdown', DropdownController)

import DashboardDemoProfileBuilderController from './dashboard/demo_profile_builder_controller'
application.register(
  'dashboard-demo-profile-builder',
  DashboardDemoProfileBuilderController,
)
import DashboardClientOverviewTimeoutController from './dashboard/client_overview_timeout_controller'

application.register(
  'dashboard_client_overview_timeout',
  DashboardClientOverviewTimeoutController,
)

import TwoFactorController from './two_factor_controller'
application.register('two-factor', TwoFactorController)

import PasswordFieldsController from './password_fields_controller'
application.register('password-fields', PasswordFieldsController)

import FlashController from './flash_controller'
application.register('flash', FlashController)

import SessionTimeoutController from './session_timeout_controller'
application.register('session-timeout', SessionTimeoutController)

import BulkDivisionUploadController from './bulk_division_upload_controller'
application.register('bulk-division-upload', BulkDivisionUploadController)

import DivisionSearchController from './division_search_controller'
application.register('division-search', DivisionSearchController)
import GlobalSubprocessorsReorderController from './global_subprocessors_reorder_controller'
application.register(
  'global-subprocessors-reorder',
  GlobalSubprocessorsReorderController,
)

import AdvantageInvitationsController from './advantage_invitations_controller'
application.register('advantage-invitations', AdvantageInvitationsController)

import NestedFieldsController from './nested_fields_controller'
application.register('nested-fields', NestedFieldsController)

import SelectContractTypeController from './select_contract_type_controller'
application.register('select-contract-type', SelectContractTypeController)

import TabsController from './tabs_controller'
application.register('tabs', TabsController)

import RegionCountrySelectorController from './region_country_selector_controller'
application.register('region-country-selector', RegionCountrySelectorController)
